import { PopupMenu, IMenuItem } from "../PopupMenu";

import LinkIcon from "@/common/images/icons/link.svg?react";
import EmbedIcon from "@/common/images/icons/embed.svg?react";
import RedditIcon from "@/common/images/icons/reddit_desktop.svg?react";
import TwitterIcon from "@/common/images/icons/twitter.svg?react";
import DiscordIcon from "@/common/images/icons/discord_desktop.svg?react";

import "./ShareGifMenu.scss";

const MENU_ITEMS = [
  {
    text: undefined,
    items: [
      {
        icon: <LinkIcon className="link" />,
        label: "Copy link",
        id: "link",
      },
      {
        icon: <EmbedIcon className="embed" />,
        label: "Embed",
        id: "embed",
      },
    ],
  },
  {
    text: "Social share:",
    items: [
      {
        icon: <RedditIcon />,
        label: "Reddit",
        className: "reddit",
        id: "reddit",
      },
      {
        icon: <TwitterIcon />,
        label: "X",
        className: "twitter",
        id: "twitter",
      },
      {
        icon: <DiscordIcon />,
        label: "Discord",
        className: "discord",
        id: "discord",
      },
    ]
  },
];

export const ShareGifMenu = (props: {
  onClick: (item: IMenuItem) => void;
  onClose: () => void;
}): JSX.Element => {
  return <PopupMenu
    className="shareGifMenu"
    onClick={props.onClick}
    onClose={props.onClose}
    groups={MENU_ITEMS}
  />;
};
